import type { PageData } from '../../../../_metronic/helpers/utils/types';

export const careerData: PageData = [
  {
    formId: 'form1',
    heading: 'Career Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' }
    ]
  }
];
